import { useSelector } from 'react-redux';
import { selectorsResponsive } from '@app/store/conversations';
import { currentUserId } from '@core/selectors/user';
import { conversationLatestMessage } from '@core/conversations/selectorsResponsive';

export const useTotalUnreadCountMessages = () => {
  const userId = useSelector(currentUserId);

  return useSelector((state: any) => {
    if (!userId) return 0;

    const conversations = selectorsResponsive.paginatedConversations(state);

    return conversations.filter((conversation: any) => {
      const isUnread = selectorsResponsive.isConversationUnreadBy?.(
        state,
        conversation.id,
        userId
      );

      if (!isUnread) return false;

      const latestMessage = conversationLatestMessage(state, conversation.id);

      // Don't count messages sent by the current user
      return latestMessage?.writer !== userId;
    }).length;
  });
};
